import React from 'react'
import { Link } from 'react-router-dom'

function OrderDetails() {
  return (
    <div>
        
    <div className="breadcrumb-row">
            <div className="container">
                <div className="row">
                    <div className="col-md-12">
                        <div className="d-flex justify-content-between align-items-center breadcrumb-item">
                            <div className="breadcrumb-title-heading">
                                <h1 className="title">Order Details</h1>
                            </div>
                            <div className="breadcrumb-wrapper">
                                <span className="mr-1"><i className="ti ti-home"></i></span>
                                <Link title="Homepage" to="/">Home</Link>
                                <span className="ttm-bread-sep">&nbsp;/&nbsp;</span>
                                <span className="ttm-textcolor-skincolor">Order Details</span>
                            </div>
                        </div>
                    </div>
                </div>  
            </div>                    
        </div>
    <section className="section-padding">
        <div className="container-fluid">
            <div className="order_user_details">
                <div className="row no-gutters">
                    <div className="col-lg-4 col-md-6">
                        <div className="details_box delivery_add">
                            <h4 className="title">Delivery Address</h4>
                            <p className="mb-2 thm-color-two">Jhon Deo</p>
                            <p>Unit 1, Wilkes Head Farm, Wilkes Head Square, Llandysul, SA44 4AA</p>
                            <h4 className="title">Phone Number</h4>
                            <p>+63 458-1175-478</p>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6">
                        <div className="details_box">
                            <h4 className="title">Your Rewards</h4>
                            <ul>
                                <li>
                                    <i className="fas fa-bolt"></i>
                                    <div className="text">
                                        <p className="thm-color-two fw-500 mb-0">6 SuperCoins</p>
                                        <p>Go to the SuperCoin Zone to know more</p>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6">
                        <div className="details_box">
                            <h4 className="title">More Actions</h4>
                            <ul>
                                <li>
                                    <i className="fas fa-download"></i>
                                    <div className="text">
                                        <p className="thm-color-two fw-500">Download Invoice</p>
                                    </div>
                                    <button type="button" className="thm-btn btn-rectangle thm-bg-color-three lh-normal mb-xl-30">Download</button>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div className="order_details_item">
                <div className="row align-items-center">
                    <div className="col-lg-4 col-md-6">
                        <div className="order_product">
                            <div className="image">
                                <img src="/tm/react/toolways/assets/images/product/grid/1.png" className="image-fit-contain" alt="img"/>
                            </div>
                            <div className="text">
                                <h6 className="title mb-0">Power Drill</h6>
                                <p className="mb-0">1pc</p>
                                <strong className="thm-color-two">$85</strong>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-6 order-lg-3">
                        <ul className="order_actions mb-xl-30">
                            <li>
                                <Link to="#">
                                    <i className="fas fa-star mr-1"></i>
                                    Rate & Review Product
                                </Link>
                            </li>
                            <li>
                                <Link to="#">
                                    <i className="fas fa-question-circle mr-1"></i>
                                    Need Help
                                </Link>
                            </li>
                        </ul>
                    </div>
                    <div className="col-lg-5 col-12 order-lg-2">
                        <ul className="order_process mb-xl-30">
                            <li className="done">
                                <span className="title">Order</span>
                                <span className="date">Thu, 2nd Nov</span>
                            </li>
                            <li className="active">
                                <span className="title">Shipped</span>
                                <span className="date">Thu, 2nd Nov</span>
                            </li>
                            <li>
                                <span className="title">Out of Delivery</span>
                                <span className="date">Thu, 2nd Nov</span>
                            </li>
                            <li>
                                <span className="title">Delivered</span>
                                <span className="date">Thu, 2nd Nov</span>
                            </li>
                        </ul>
                    </div>
                </div>
                <p className="lh-normal">Product has no-return policy <Link to="/privacy">Know More</Link></p>
            </div>
        </div>
    </section>
    </div>
  )
}

export default OrderDetails